import { usePathname, useRouter } from 'next/navigation';

import {
  Button,
  MainModalController,
  Modal,
  ModalClose,
  ModalCloseButton,
  ModalContent,
} from '@uikit';

import Checked from '@uikit/icons/Checked';

import KarmaTag from '@shared/common/components/KarmaTag';

export interface KarmaLimitModalProps {
  modalController: MainModalController;
  karmaPoints: number;
}

export default function KarmaLimitModal({
  modalController: modal,
  karmaPoints,
}: KarmaLimitModalProps) {
  const pathname = usePathname();
  const router = useRouter();

  const handleOnOpenChange = (value: boolean) => {
    router.replace(pathname);

    modal.props.onOpenChange(value);
  };

  const modalProps = { ...modal.props, onOpenChange: handleOnOpenChange };

  return (
    <Modal {...modalProps}>
      <ModalContent className="items-center p-0">
        <ModalCloseButton className="m-4" />

        <div className="flex flex-col items-center p-10 pt-0 gap-3">
          <div className="flex items-center justify-center w-[70px] aspect-square bg-yellow-600 rounded-full">
            <Checked className="icon text-neutral-50" />
          </div>

          <h5 className="text-neutral-700 t-h4 text-2xl">Insufficient Karma Points!</h5>

          <p className="flex items-center t-body2 text-neutral-400 text-center gap-2">
            You need
            <div className="flex items-center justify-center gap-1 text-secondary-600">
              <KarmaTag points={karmaPoints} />
              Karma
            </div>
            Karma Points to claim this offer.
          </p>

          <ModalClose className="w-full">
            <Button variant="primary" size="md" label="Continue" className="w-full mt-4" />
          </ModalClose>
        </div>
      </ModalContent>
    </Modal>
  );
}
